@file:OptIn(InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/chartsproject.app.generated.resources/"

@delegate:ResourceContentHash(722_207_067)
internal val Res.drawable.ic_bar_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_bar_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bar_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_502_484_583)
internal val Res.drawable.ic_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_720_401_342)
internal val Res.drawable.ic_dark_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_168_786_107)
internal val Res.drawable.ic_github: DrawableResource by lazy {
      DrawableResource("drawable:ic_github", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_405_938_115)
internal val Res.drawable.ic_launcher_foreground: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher_foreground", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher_foreground.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_109_290_915)
internal val Res.drawable.ic_line_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_line_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_line_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_166_240_115)
internal val Res.drawable.ic_multi_line_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_multi_line_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_multi_line_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_621_484_548)
internal val Res.drawable.ic_pie_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_pie_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_pie_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-345_073_621)
internal val Res.drawable.ic_radar_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_radar_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_radar_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-536_874_291)
internal val Res.drawable.ic_replay: DrawableResource by lazy {
      DrawableResource("drawable:ic_replay", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_replay.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(500_687_149)
internal val Res.drawable.ic_stacked_bar_chart: DrawableResource by lazy {
      DrawableResource("drawable:ic_stacked_bar_chart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_stacked_bar_chart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_794_967_508)
internal val Res.drawable.ic_visibility_off: DrawableResource by lazy {
      DrawableResource("drawable:ic_visibility_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_visibility_off.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(699_330_369)
internal val Res.drawable.ic_visibility_on: DrawableResource by lazy {
      DrawableResource("drawable:ic_visibility_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_visibility_on.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_bar_chart", Res.drawable.ic_bar_chart)
  map.put("ic_check", Res.drawable.ic_check)
  map.put("ic_dark_mode", Res.drawable.ic_dark_mode)
  map.put("ic_github", Res.drawable.ic_github)
  map.put("ic_launcher_foreground", Res.drawable.ic_launcher_foreground)
  map.put("ic_line_chart", Res.drawable.ic_line_chart)
  map.put("ic_multi_line_chart", Res.drawable.ic_multi_line_chart)
  map.put("ic_pie_chart", Res.drawable.ic_pie_chart)
  map.put("ic_radar_chart", Res.drawable.ic_radar_chart)
  map.put("ic_replay", Res.drawable.ic_replay)
  map.put("ic_stacked_bar_chart", Res.drawable.ic_stacked_bar_chart)
  map.put("ic_visibility_off", Res.drawable.ic_visibility_off)
  map.put("ic_visibility_on", Res.drawable.ic_visibility_on)
}
